/**
 * @module app\menu
 */
import { Component, Watch, Provide } from "vue-property-decorator";
import { TreeNode } from "element-ui/types/tree";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import GhBase from "@/components/ghBase";

@Component
export default class Menu extends GhBase {
  private tabs: IGhTab[] = [
    { title: "系统菜单", drawer: true },
    { title: "菜单维护", drawer: false }
  ];

  private parent: IndexObject = {};
  private argsQuery = { parent_id: "" };

  private beforeIntial(prop: ITableRowProps) {
    let options: { [key: string]: ITableRowOption } = {};
    if (prop.item && !prop.item.dynamic) {
      options["O-dynamic-config"] = {
        hideActions: ["config"]
      };
    }
    return options;
  }

  @Watch("parent")
  private parentChanged() {
    if (this.parent) {
      this.argsQuery.parent_id = this.parent.key;
      let table = this.$refs.table as GhTablePage;
      table.query(this.argsQuery);
    }
  }

  private beforeSave(item: IndexObject) {
    if (this.parent) {
      if (item.ParentId === "-1") {
        item.ParentId = "";
      } else {
        item.ParentId = this.parent.key;
      }
    }
  }

  private configPage(item) {
    this.navigate("/sys/menu/menuConfig/menuConfig", item);
  }
}
